import React, { Component } from "react";
import UserAPIs from "../../APIs/UserAPIs";
import "./impersonate.css";
import { connect } from "react-redux";
import actions from "../../store/actions";
import { save } from "../../helpers/helperFunctions";
// import mixpanel from "mixpanel-browser";

class ImpersonateWindow extends Component {
  state = {
    errMsg: "",
    busy: false,
  };

  componentDidMount() {
    UserAPIs.verifyToken().catch(err => {
      if(err.response) {
        this.logout();
      }
    })
  }

  login = () => {
    let username = this.input.value;
    if (username) {
      this.setState({ errMsg: "", busy: true });
      let authUsername = this.props.auth.userinfo.username;
      if (authUsername === username) return this.skip();
      UserAPIs.impersonate({
        impusername: username,
        app: "track",
      })
        .then((rsp) => {
          rsp = {
            ...rsp,
            loggedInAt: Date.now(),
          };
          save("auth-user", this.props.auth);
          save("intelli-auth", { 0: rsp });
          window.location.reload();
          // mixpanel.track("User Clicked Impersonate", {
          //   Platform: "Web",
          //   Application: "Web",
          //   Screen: "Impersonate",
          // });
        })
        .catch((err) => {
          if (err.response) {
            this.setState({ errMsg: err.response.data.msg, busy: false });
          }
        });
    } else {
      this.setState({ errMsg: "" });
    }
  };

  logout = () => {
    this.props.dispatch({
      type: actions.AUTH_FAILURE,
    });
  };

  onKeyDown = (e) => {
    if (e.keyCode === 13) this.login();
  };

  // skip impersonation
  skip = () => {
    save("intelli-auth", { 0: { ...this.props.auth, skipImp: true } });
    window.location.reload();
  };
  
  render() {
    return (
      <div className="imp-w" onKeyDown={this.onKeyDown}>
        <div className="imp-wc" onClick={(e) => e.stopPropagation()}>
          <div className="imp-st">
            <h1>Impersonate as</h1>
            <div className="grp">
              <input
                type="text"
                placeholder="Username"
                ref={(ref) => (this.input = ref)}
              />
            </div>
            <div className={"btns" + (this.state.busy ? " busy" : "")}>
              <button className="btb" onClick={this.login}>
                {this.state.busy && (
                  <div className="lod">
                    <div></div>
                  </div>
                )}{" "}
                Impersonate
              </button>
            </div>
            <div className={"btns"}>
              <button className="bto" onClick={this.skip}>
                Skip
              </button>
            </div>
            {this.state.errMsg && (
              <div className="err ctr">{this.state.errMsg}</div>
            )}
          </div>
          <div className="imp-sb">
            <div className="lnk">
              <button onClick={this.logout}>Logout</button>
              <div className="loged">Logged in as {this.props.auth.userinfo.username}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapPropsToState = (state) => {
  return { auth: state.auth };
};

export default connect(mapPropsToState)(ImpersonateWindow);
